export default __webpack_public_path__ + "static/media/Reveal-nft.ae25aae7.svg";